import { FILTER_ACCOMMODATIONS, FILTER_TOURS, CLEAR_FILTER } from '../actions/types';

const initialState = {
    filteredAccommodations: [],
    filteredTours: [],
    searchDataAccomm: {
        checked: []
    },
    searchDataTour: {
        checked: []
    }
};

export default function (state = initialState, action) {
    switch (action.type) {
        case FILTER_ACCOMMODATIONS:

            action.searchDataAccomm.checked = action.searchDataAccomm.full_lease===true ? [1] : [];

            return {
                ...state,
                filteredAccommodations: action.payload,
                searchDataAccomm: action.searchDataAccomm
            };
        case FILTER_TOURS:

            action.searchDataTour.checked = action.searchDataTour.full_lease===true ? [1] : [];

            return {
                ...state,
                filteredTours: action.payload,
                searchDataTour: action.searchDataTour
            };
        case CLEAR_FILTER:
            return initialState;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/filtersReducer.js